import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getMockCart } from '@utils/mockUtils';
import urlList from '@utils/urlList';
import { setShowSessionModal, setGenericErrorModal } from '../actions/index';
import { getLabelFallback } from '@utils/utils';

/* LOADING */
export const startLoading = () => {
    return {
        type: actionTypes.START_LOADING
    }
}

export const endLoading = () => {
    return {
        type: actionTypes.END_LOADING
    }
}

export const errorLoading = () => {
    return {
        type: actionTypes.ERROR_LOADING
    }
}

/* CART */
export const getCart = (mockRequests: boolean, hostname: string) => {
    return (dispatch) => {
        const url = hostname + urlList['GET_CART'] + '?nocache=' + new Date().getTime();
        
        dispatch(startLoading());
        return (mockRequests 
            ? getMockCart()
            : axios({
                url,
                method: 'GET',
                withCredentials: true,
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            })
        )
            .then((res: any) => {
                window.userCartDetails = res.data;
                dispatch(getCartSuccess(res.data));
            })
            .catch((err) => {
                if(!!err && !!err.response) {
                    console.error('>>> Get cart => error status:', err.status, ', error: ', err);
                    switch (err.response.status){
                        case 401:
                        case 403: dispatch(setShowSessionModal(true));
                            break;
                        case 404: dispatch(getCartFailure());
                            break;
                        default: dispatch(setGenericErrorModal(true, getLabelFallback('GENERIC_ERROR_MODAL_TEXT_LINE')));
                    } 
                } 
            })
    };
};

/* SPEEDY */
export const getSpeedyDetails = (hostname: string, orderId:  string) => {
    return (dispatch) => {
        const url = hostname + urlList['GET_SPEEDY_DETAILS'].replace('##ORDERID##', orderId).replace('##NOCACHE##', '' + new Date().getTime())

        if(url) {
        axios({
            url,
            method: 'GET',
        }).then((response: any) => {
            dispatch(setSpeedyOrderDetails(response.data));
        })
        .catch((err: any) => {
            console.log("Error retrieving speedy order details -> " + err)
        })
        }
    }
}

const setSpeedyOrderDetails = (speedyOrderDetails) => {
    return {
        type: actionTypes.SET_SPEEDY_ORDER_DETAILS,
        speedyOrderDetails,
    }
}

export const getCartRequest = () => {
    return {
        type: actionTypes.GET_CART_REQUEST
    }
}

export const getCartSuccess = (cart) => {
    return {
        type: actionTypes.GET_CART_SUCCESS,
        cart
    }
};

export const getCartFailure = () => {
    return {
        type: actionTypes.GET_CART_FAILURE
    }
}

/* ORDER ITEMS */
export const setFormattedOrderItems = (items) => {
    return {
        type: actionTypes.SET_FORMATTED_ORDER_ITEMS,
        items
    }
}
